import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { Iconify } from 'src/components';
import { tipBlockSx, tipIconSx, tipTextSx } from '../styles';

const TipBlock = ({
  text,
  icon = 'lightbulb',
  children,
  sx = {},
}) => {
  const iconName = icon === 'info' ? 'mdi:information-outline' : 'mdi:lightbulb-outline';

  return (
    <Box sx={{ ...tipBlockSx, ...sx }}>
      <Iconify icon={iconName} sx={tipIconSx} width={20} height={20} />
      {text ? (
        <Typography sx={tipTextSx}>{text}</Typography>
      ) : (
        <Box sx={tipTextSx}>{children}</Box>
      )}
    </Box>
  );
};

TipBlock.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.oneOf(['lightbulb', 'info']),
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default TipBlock;
